import { render, staticRenderFns } from "./CultivationTable.vue?vue&type=template&id=b6645824&scoped=true&"
import script from "./CultivationTable.vue?vue&type=script&lang=js&"
export * from "./CultivationTable.vue?vue&type=script&lang=js&"
import style0 from "./CultivationTable.vue?vue&type=style&index=0&id=b6645824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6645824",
  null
  
)

export default component.exports